import axios from "axios";
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
const baseURL = import.meta.env.VITE_ROOT_API;

const apiClient = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
  
  }
});

apiClient.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    /*if (error.response && error.response.status === 401) {
      store.dispatch("auth/logoutRequest");
    } else {
      return Promise.reject(error);
    }*/
    return Promise.reject(error);
  }
);

export default {
  get(api, config = null) {
    return apiClient.get(api, config);
  },
  post(api, payload, config = null) {
    return apiClient.post(api, payload, config);
  },
  delete(api, config = null) {
    return apiClient.delete(api, config);
  },
  put(api, payload, config = null) {
    return apiClient.put(api, payload, config);
  },
  patch(api, payload, config = null) {
    return apiClient.patch(api, payload, config);
  }
};
